import axiosInstance from "./axiosInstance";

export const fetchAddonSummary = () => axiosInstance.get("/admin/addon-requests/summary");

export const createAddonRequest = (data) => axiosInstance.post("/admin/addon-requests", data);

export const fetchAddonRequests = () => axiosInstance.get("/superadmin/addon-requests");

export const updateAddonRequestStatus = (id, status, notes = "") =>
  axiosInstance.patch(`/superadmin/addon-requests/${id}/status`, { status, notes });
